import { bindActionCreators } from 'redux'
import { RedeemGift } from '@piconetworks/gift'
import withInjection from '@piconetworks/with-injection'

import Internal from 'common/modules/internal'
import Loader from 'common/modules/loader'
import Gift from 'common/modules/gift'
import xFrame from 'common/xFrame'

import { WizardError } from 'common/pkgs/WizardRedux'

const mapStateToProps = (state, props) => ({
    ...props,
    giftId: props?.router?.query?.gift_id,
    redeemingGift: state.gift.redeemingGift,
    redeemGiftSuccess: state.gift.redeemGiftSuccess,
    redeemGiftError: state.gift.redeemGiftError,
    redeemGiftErrorMessage: state.gift.redeemGiftErrorMessage,
    linkColor: Loader.selectors.linkColor(state),
    publisherId: Loader.selectors.publisherId(state),
    isGiftedSub: Loader.selectors.currentSubscriptionIdIsGift(state),
    WizardError,
    canSubmit: props?.canSubmit,
})

const mapDispatchToProps = (dispatch) => ({
    ...bindActionCreators({
        redeemGift: (payload) => Internal.helpers.invalidateLoader({
            payload,
            action: Gift.creators.redeemGift,
            dispatch,
        }),
    }, dispatch),
    dispatch,
})

const mergeProps = (stateProps, dispatchProps, ownProps) => ({
    ...ownProps,
    ...stateProps,
    ...dispatchProps,
    redeemGift: () => {
        if (stateProps?.canSubmit) {
            dispatchProps.redeemGift({
                giftId: stateProps.giftId,
                publisherId: stateProps.publisherId,
            })
        } else {
            stateProps.canSubmitError('stateProps.redeemGiftErrorMessage')
        }
    },
    onComponentDidMount: () => {
        const { wizard: wizardStore } = stateProps
        dispatchProps.onComponentDidMount(wizardStore)
    },
    onRedeemGiftError: () => {
        xFrame.prompt.showThankYou({
            thankYouText: stateProps.redeemGiftErrorMessage,
            dispatch: dispatchProps.dispatch,
        })
    },
    onRedeemGiftSuccess: () => {
        stateProps.submissionSuccess({
            thankYouText: stateProps.isGiftedSub ? 'This gift has already been redeemed.' : 'Your gift has been redeemed successfully.',
        })
    },
})

const InjectedGift = withInjection(RedeemGift, {
    mapStateToProps,
    mapDispatchToProps,
    mergeProps,
})

export default InjectedGift
